import { PUT_REDUX_GENERAL_SETTINGS } from '../../reducers/constants';

const putReduxGeneralSettings = (generalSettings) => ({
  type: PUT_REDUX_GENERAL_SETTINGS,
  generalSettings,
});

export default putReduxGeneralSettings;
